










import { Component, Prop, Vue } from 'vue-property-decorator';
import CreditAccountForm from './CreditAccountForm.vue';
import { ACCOUNTS_PAYABLE } from '../../statics';

@Component({
  components: {
    CreditAccountForm
  }
})
export default class AccountsPaymentForm extends Vue {
  @Prop({ type: String, required: true }) listOfAssetsId!: string;

  type = ACCOUNTS_PAYABLE;
}
